// extracted by mini-css-extract-plugin
export var quillEditor = "_hi-1";
export var variable = "_hi-0";